import { render, staticRenderFns } from "./SendMessageReplyListTable.vue?vue&type=template&id=3b7d34be&scoped=true&lang=pug"
import script from "./SendMessageReplyListTable.vue?vue&type=script&lang=ts"
export * from "./SendMessageReplyListTable.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageReplyListTable.vue?vue&type=style&index=0&id=3b7d34be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7d34be",
  null
  
)

export default component.exports